/**
 * Infinite scroll for paginated product grids (collection and search pages).
 *
 * A sentinel placed after the grid loads the next page as it comes into view and
 * appends its cards. The numbered pagination stays in the markup as the no-JS
 * fallback and is only hidden once this script takes over.
 */
(function () {
  var CONTAINER_ID = 'ProductGridContainer';
  var LOAD_AHEAD = '800px'; // start fetching this far before the sentinel is visible

  function setup(container) {
    var grid = container.querySelector('#product-grid');
    var wrapper = container.querySelector('.pagination-wrapper');
    if (!grid || !wrapper) return;
    if (wrapper.dataset.infiniteScroll) return; // already wired up
    wrapper.dataset.infiniteScroll = 'on';

    // Hidden either way: on the last page there is nothing left to page through.
    wrapper.hidden = true;

    var nextUrl = wrapper.getAttribute('data-next-url');
    if (!nextUrl) return;

    var sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll';
    sentinel.innerHTML = '<span class="infinite-scroll__spinner" aria-hidden="true"></span>';
    sentinel.setAttribute('role', 'status');
    wrapper.parentNode.insertBefore(sentinel, wrapper);

    var loading = false;
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) load();
      },
      { rootMargin: LOAD_AHEAD }
    );
    observer.observe(sentinel);

    function stop() {
      observer.disconnect();
      if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    }

    function load() {
      if (loading || !nextUrl) return;
      loading = true;
      sentinel.classList.add('is-loading');

      fetch(nextUrl)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newGrid = doc.querySelector('#product-grid');
          if (!newGrid) throw new Error('no grid');

          // Cap the stagger so a full page of cards does not trickle in slowly.
          var items = newGrid.children;
          var fragment = document.createDocumentFragment();
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.style.getPropertyValue('--animation-order')) {
              item.style.setProperty('--animation-order', Math.min(i + 1, 8));
            }
            fragment.appendChild(item.cloneNode(true));
          }
          grid.appendChild(fragment);

          var newWrapper = doc.querySelector('.pagination-wrapper');
          nextUrl = newWrapper ? newWrapper.getAttribute('data-next-url') : null;

          loading = false;
          sentinel.classList.remove('is-loading');
          if (!nextUrl) stop();
        })
        .catch(function () {
          // Leave the pagination as a way out if a page fails to load.
          loading = false;
          sentinel.classList.remove('is-loading');
          wrapper.hidden = false;
          stop();
        });
    }
  }

  function init() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    setup(container);

    // Filtering and sorting replace the container's contents outright, which
    // discards the sentinel and resets the grid to page one.
    new MutationObserver(function () {
      setup(container);
    }).observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
